export default url => url.split(/[?#]/)[0];
